// extracted by mini-css-extract-plugin
export default {"list":"NavButton_list__+xOld","active":"NavButton_active__jENHe","fall":"NavButton_fall__WYO9m","float":"NavButton_float__DPsvg","button":"NavButton_button__KLDqA"};